import React from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

import SmallTileComponent from './SmallTileComponent';

const SmallDraggableTileContainer = styled.div`
  margin-right: 16px;
`;

const SmallDraggableTile = ({
  id,
  index,
  thumbnail,
  headline,
  fullyAssembled,
  planDate,
  loading,
  ignored,
  status,
  editPath,
  embedVideo,
  ribbonTagName,
  ribbonTagColor,
  tileShowPath,
  audienceColor,
}) => (
  <Draggable
    draggableId={`${id}`}
    index={index}
    isDragDisabled={status === 'user_submitted'}
  >
    {provided => (
      <SmallDraggableTileContainer
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <SmallTileComponent
          id={id}
          headline={headline}
          thumbnail={thumbnail}
          fullyAssembled={fullyAssembled}
          planDate={planDate}
          status={status}
          loading={loading}
          draggable={true}
          ignored={ignored}
          editPath={editPath}
          embedVideo={embedVideo}
          ribbonTagName={ribbonTagName}
          ribbonTagColor={ribbonTagColor}
          tileShowPath={tileShowPath}
          audienceColor={audienceColor}
          currentTab="plan"
        />
      </SmallDraggableTileContainer>
    )}
  </Draggable>
);

SmallDraggableTile.propTypes = {
  id: PropTypes.string,
  index: PropTypes.number,
  thumbnail: PropTypes.string,
  headline: PropTypes.string,
  fullyAssembled: PropTypes.bool,
  planDate: PropTypes.string,
  loading: PropTypes.bool,
  ignored: PropTypes.bool,
  status: PropTypes.any,
  editPath: PropTypes.string,
  embedVideo: PropTypes.any,
  ribbonTagName: PropTypes.string,
  ribbonTagColor: PropTypes.string,
  tileShowPath: PropTypes.string,
  audienceColor: PropTypes.string,
};

export { SmallDraggableTile };
